// CPF/CNPJ — incluindo CNPJ ALFANUMÉRICO (NT 2026.004 / IN RFB nº 2.229).
// Espelho de backend/src/utils/documento.js: a partir de julho/2026 CNPJs
// podem ter letras nas 12 primeiras posições (DVs continuam numéricos; no
// cálculo cada caractere vale código ASCII − 48). NUNCA limpar CNPJ com
// replace(/\D/g,'') — remove as letras.

export function limparDocumento(v) {
  return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}

const valorChar = c => c.charCodeAt(0) - 48;

function dvCnpj(base, pesos) {
  const soma = [...base].reduce((acc, c, i) => acc + valorChar(c) * pesos[i], 0);
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

export function validarCnpj(cnpj) {
  const d = limparDocumento(cnpj);
  if (!/^[A-Z0-9]{12}\d{2}$/.test(d)) return false;
  if (/^(.)\1{13}$/.test(d)) return false;
  const dv1 = dvCnpj(d.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  if (dv1 !== parseInt(d[12])) return false;
  return dvCnpj(d.slice(0, 12) + d[12], [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === parseInt(d[13]);
}

export function validarCpf(cpf) {
  const d = limparDocumento(cpf);
  if (!/^\d{11}$/.test(d)) return false;
  if (/^(\d)\1{10}$/.test(d)) return false;
  for (const n of [9, 10]) {
    let soma = 0;
    for (let i = 0; i < n; i++) soma += parseInt(d[i]) * (n + 1 - i);
    if (((soma * 10) % 11) % 10 !== parseInt(d[n])) return false;
  }
  return true;
}

// null = válido (vazio ok); string = mensagem de erro
export function erroDocumento(v) {
  const d = limparDocumento(v);
  if (!d) return null;
  if (d.length === 11) return validarCpf(d) ? null : 'CPF inválido — confira os dígitos.';
  if (d.length === 14) return validarCnpj(d) ? null : 'CNPJ inválido — confira os dígitos (CNPJs novos podem conter letras).';
  return 'CPF/CNPJ deve ter 11 (CPF) ou 14 (CNPJ) caracteres.';
}

// CPF 000.000.000-00 / CNPJ XX.XXX.XXX/XXXX-XX (alfanumérico incluso)
export function formatarDocumento(v) {
  const d = limparDocumento(v);
  if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
  if (d.length === 14) return d.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
  return v || '';
}
